module.exports = __webpack_public_path__ + "../resources/img/ic_re_standby_default.6871ffa2.svg";